<router-outlet />
<!-- Secondary, lazy-loaded router outlet (for the universal analytics component) -->
<router-outlet name="analytics" />
